/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type ListAgentOptimizationResultsPathParams = NonNullable<
  operations['listAgentOptimizationResults']['parameters']['path']
>;

export type ListAgentOptimizationResultsQueryParams = NonNullable<
  operations['listAgentOptimizationResults']['parameters']['query']
>;

export interface Input extends ListAgentOptimizationResultsPathParams {
  apiVersion?: string;
  query?: ListAgentOptimizationResultsQueryParams;
}

export async function listAgentOptimizationResults(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/agent-optimizations/{optimizationKey}/results', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
